import React from 'react';

// Default value is defined in FeatureFlagsContextProvider
export const FeatureFlagsContext = React.createContext({});
